import CountrySelectDrawer from './country-select-drawer';

const init = () => {
    if (!window.customElements.get('country-select-drawer')) {
        window.customElements.define('country-select-drawer', CountrySelectDrawer);

        // Open the CountrySelectDrawer if the 'selected_country' cookie is not present
        const hasSelectedCountryCookie = /(?:^|;\s*)selected_country=([^;]+)/.test(document.cookie);
        if (!hasSelectedCountryCookie) {
            // Wait for full load to ensure the element in the footer exists
            window.addEventListener('load', () => {
                const countryDrawer = document.querySelector('country-select-drawer');
                countryDrawer?.show?.();
            });
        }
    }

    const closeButtons = document.querySelectorAll('.js-close-drawer-button');
    if (closeButtons.length > 0) {
        closeButtons.forEach((button) => {
            button.addEventListener('click', () => button.dispatchEvent(
                new CustomEvent('dialog:force-close', {
                    bubbles: true,
                    cancelable: true,
                    composed: true,
                }),
            ));
        });
    }
};

export default init;
